export class Rating {
  public rating: number;
  public total: number;
  public updatedAt: number;
  public values: any;

  constructor(rating: number, total: number, updatedAt: number, values: any) {
    this.rating = rating;
    this.total = total;
    this.updatedAt = updatedAt;
    this.values = values;
  }

  public static mapFromFirestore(rating: any): Rating {
    if (!rating) { return null; }
    return new Rating(
      rating.rating,
      rating.total,
      rating.updatedAt,
      rating.values
    );
  }

  public mapToFirestore(): any {
    return {
      rating: this.rating,
      total: this.total,
      updatedAt: this.updatedAt,
      values: this.values
    };
  }
}
